import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import Apk from './components/Apk';
import { IApkAssignmentContext, ApkAssignmentContext } from '../../../../apkAssignmentState/apkAssignmentContext';
import style from './ApkList.module.scss';

const ApkList: React.FC = () => {
	const { apkForAssign } = useContext<IApkAssignmentContext>(ApkAssignmentContext);

	return (
		<div className={style.container} data-test="ApkList">
			<div className={style.tableOfContents}>
				<Text
					className={style.name}
					translationNameSpace="listing"
					translationKey="versionNameLabel"
					theme="neutralLight"
				/>
				<Text
					className={style.type}
					translationNameSpace="listing"
					translationKey="applicationApkTypeLabel"
					theme="neutralLight"
				/>
			</div>
			{apkForAssign.items.map((el) => (
				<Apk data={el} key={el.id + 'apkList'} />
			))}
		</div>
	);
};

export default ApkList;
